import { LoadingOutlined } from '@ant-design/icons'
import { Button, Input, Result, Tabs, Form } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../redux/context/company/selectors'
import { useBackend } from '../../../../../services/backend'
import { OscarApiCredentials } from '../types'
import { notificationAction } from '../../../../../redux/middleware/actions'
import { useIntegrationDocsURL } from '../../../../../utils/docs'
import Loading from '../../../../../shared/components/Loading'
import DataUpdate from '../dataUpdate'

const Oscar: React.FC = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()
  const companyId = useSelector(contextCompanyIdSelector)
  const getCredentials = useBackend(`/oscar/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)
  const setCredentials = useBackend(`/oscar/authentication/{companyId}`, process.env.REACT_APP_INTEGRATION_URL)
  const dispatch = useDispatch()

  const [apiKey, setApiKey] = useState<string>()
  const [authorized, setAuthorized] = useState<boolean>(false)

  const getCredentialsHandler = () => {
    getCredentials
      .get({
        urlParams: { companyId }
      })
      .then((credentials: OscarApiCredentials) => {
        if (credentials.apiKey) {
          setAuthorized(true)
        } else {
          setApiKey('')
          setAuthorized(false)
        }
      })
      .catch((err: any) => {
        setApiKey('')
        setAuthorized(false)
        console.log(err)
      })
  }

  useEffect(getCredentialsHandler, [companyId])

  const submit = () => {
    setCredentials
      .put({
        urlParams: { companyId },
        body: {
          data: {
            apiKey
          }
        }
      })
      .then((credentials: OscarApiCredentials) => {
        if (credentials.apiKey) {
          setAuthorized(true)
        }
        dispatch(
          notificationAction({
            type: 'success',
            message: 'AUTHENTICATION_SUCCESS'
          })
        )
      })
      .catch(() => {
        dispatch(
          notificationAction({
            type: 'error',
            message: 'AUTHENTICATION_ERROR'
          })
        )
      })
  }

  const authButton = () => {
    return (
      <>
        <Button type="primary" onClick={() => setAuthorized(false)}>
          {t('integrationsPage:authenticate')}
        </Button>
        <DataUpdate page="oscar" />
      </>
    )
  }

  if (getCredentials.loading) {
    return <Loading />
  }

  const items = [
    {
      label: t('integrationsPage:api'),
      key: 'item-1',
      children: authorized ? (
        <>
          <Result status="success" title={t('integrationsPage:authenticated')} extra={authButton()} />
        </>
      ) : (
        <Form layout="vertical">
          <Form.Item label="ApiKey">
            <Input
              value={apiKey}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setApiKey(event.target.value)}
              suffix={getCredentials.loading && <LoadingOutlined />}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" onClick={() => submit()} loading={setCredentials.loading}>
              {t('integrationsPage:authenticate')}
            </Button>
          </Form.Item>
        </Form>
      )
    }
  ]

  return (
    <>
      <a href={integrationDocs.accounting('oscar')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Tabs defaultActiveKey="item-1" items={items} />
    </>
  )
}

export default Oscar
